<template>
  <section>
    <card v-for="produto in this.produtos" :produto="produto" :key="'itempromocaoa-'+produto.id" ></card>
  </section>
</template>

<script>
  import Card from "./Card";
  export default {
    name: "ProdutosContainerFlex",
    components: {Card},
    props:["produtos"]
  }
</script>

<style scoped>
  body{
    margin: 0;
  }
  section{
    column-count: 2;
    column-gap: 5px;
    padding: 5px;
  }
  section img{
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Widgets/Produto/ProdutosContainerFlex.vue